
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","version":"1.1","id":"info-color-Capa_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 487.65 487.65","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('path',{attrs:{"d":"M243.824 0C109.163 0 0 109.163 0 243.833 0 378.487 109.163 487.65 243.824 487.65c134.662 0 243.826-109.163 243.826-243.817C487.65 109.163 378.486 0 243.824 0zm-.062 103.634c20.416 0 36.977 16.555 36.977 36.977 0 20.425-16.561 36.978-36.977 36.978-20.424 0-36.986-16.553-36.986-36.978-.001-20.422 16.562-36.977 36.986-36.977zm63.519 277.594a6.69 6.69 0 01-6.684 6.691H186.933a6.688 6.688 0 01-6.683-6.691v-13.719a6.687 6.687 0 016.683-6.689h21.492V230.706h-22.153a6.69 6.69 0 01-6.685-6.692V210.28a6.69 6.69 0 016.685-6.69h86.35a6.69 6.69 0 016.683 6.69v150.539h21.293a6.689 6.689 0 016.684 6.689v13.72z"}})])])
          )
        }
      }
    